var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page",
    on: {
      mouseenter: _vm.enters,
      mouseleave: _vm.leaver
    }
  }, [_vm.itemObj.isHomePage ? _c("a-tag", {
    staticClass: "tag",
    attrs: {
      color: "blue"
    }
  }, [_vm._v(_vm._s(_vm.$t("首页")) + " ")]) : _vm._e(), _vm._l(_vm.arr2, function (item, index) {
    return _c("mobile-preview", {
      key: index + 1,
      attrs: {
        itemObj: item,
        itemIndex: index,
        arrNum: _vm.arr2.length - 1,
        themeColor: _vm.themeColor,
        isConfigure: false,
        pageType: _vm.itemObj.controlsGroupPageType,
        pageDescription: _vm.pageDescription,
        pageDescriptionConfig: _vm.pageDescriptionConfig
      }
    });
  }), _vm.pageModalShow ? _c("div", [_c("div", {
    staticStyle: {
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.5)",
      position: "absolute",
      left: "0",
      top: "0",
      "z-index": "1"
    },
    on: {
      click: function ($event) {
        _vm.pageModalShow = false;
      }
    }
  }), _c("page-modal", {
    attrs: {
      pagePopUpConfig: _vm.pagePopUpConfig
    },
    on: {
      popupClick: function ($event) {
        _vm.pageModalShow = false;
      }
    }
  })], 1) : _vm._e(), _vm.isObscuration ? _c("div", {
    staticClass: "obscurationBox"
  }, [_c("div", {
    staticClass: "bg"
  }), _c("a-button", {
    staticStyle: {
      position: "static",
      "z-index": "4"
    },
    on: {
      click: _vm.homeFun
    }
  }, [_vm._v(_vm._s(_vm.$t("设置首页")))])], 1) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };